var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"button-custom",on:{"click":_vm.previewPdf}},[_vm._v("Actualiser")])}
var staticRenderFns = []

export { render, staticRenderFns }